import Rest from '@/services/Rest';

export default class CategoryService extends Rest {
  static resource = 'category';
}
